import React, { Component } from "react";
import MoneyInput, { cleanValue } from "./../../money-input/MoneyInput";
import { MoneyInput as SparkMoneyInput } from "react-spark";

export const validation = {
  validateOn: ["blur"],
  required: true,
  checkValidity: value => {
    const cleanedValue = cleanValue(value);
    const amount = parseFloat(cleanedValue);

    if (!SparkMoneyInput.pattern.test(value)) {
      return {
        isValid: false
      };
    }

    if (amount < 1) {
      return {
        isValid: false,
        inputAttr: "minlength"
      };
    }

    return {
      isValid: true
    };
  },
  message: {
    default: "Please enter your desired payment amount",
    minlength: "Your payment is below $1"
  }
};

class AnnualGrossIncome extends Component {

  static cleanValue = cleanValue;
  render() {
    const { className, value, parentContainerClassName, disabled } = this.props;
    return (
      <MoneyInput
        id="paymentAmount"
        name="paymentAmount"
        label="Payment Amount"
        placeholder="0.00"
        validation={validation}
        value={value}
        className={className}
        parentContainerClassName={parentContainerClassName}
        disabled={disabled}
        type={'text'}
      />
    );
  }
}

export default AnnualGrossIncome;
